module.exports = __webpack_public_path__ + "static/media/pocket-logo.b363d820.svg";